import React from 'react'
import { SuccessPage } from 'components'

export default function YTSuccess() {
  return <SuccessPage />
}
